<template >
    <div class="product-list-element" :class="{ updating }" >
        <img class="cdn-image" :src="cdnImage"/>
        <div class="details-box" >
            <div class="display-series">{{seriesIdentifier}}</div>
            <div class="sales-name">{{product.salesName}}</div>
            <div class="sku">{{$t('common.sku')}} {{product.SKU}}</div>
        </div>

      <div class="pricing-box" v-if="mode == 'replacement'" >
        <img v-if="!alreadyAdded" style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="setReplacementProduct" src="@/assets/PlusGreen.svg"/>
        <img v-else style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="clearReplacementProduct" src="@/assets/RemoveCart.svg"/>

      </div>
    </div>

</template>

<script>
 export default {
     name: "ProductReplacementListElement",
     props: {
         updating: { type: Boolean, default: false },
       alreadyAdded: { type: Boolean, default: false },
         mode: { type: String, default: 'list' },
         product: {
             avatar: '',
             salesName:'',
             defaultPrice: 0,
             displaySeries:'',
             SKU:'',
             availability: {
                 state: {
                     state: "active",
                     message: "Tilgjengelig",
                     buyable: true
                 },
                 roof: 250,
                 qty: 0
             }
         },
         historic: { type: Boolean, default: false },

     },
     computed:{
         cdnImage(){
             let avatarFile = ''
             if(this.product.images.productMain != null){
                 if(this.product.images.productMain.length > 0){
                     if(this.product.images.productMain[0].image){
                         avatarFile = this.product.images.productMain[0].image.name
                     }
                 }
             }
             if (avatarFile == null){
                 return 'https://perfecthome.com/images/logo.svg'
             } else {
                 if (avatarFile.length > 0){
                     return `${process.env.VUE_APP_CDN_URL}images/pim/202/${avatarFile}`
                 } else {
                     return 'https://perfecthome.com/images/logo.svg'
                 }
             }
         },
         isHistoric(){
             if (this.historic == true){
                 console.log("is historic: " . this.product.SKU);
                 return true;
             }
             //console.log("is NOT historic");
             return false;
         },
         seriesIdentifier(){
             return this.product.displaySeries.toUpperCase()
             // return this.product.salesName.substr(0, this.product.salesName.indexOf(' ')).toUpperCase()
         },
         hasOfferPrice(){
             if (this.product.offerPrice < this.product.defaultPrice){
                 return true
             }
             return false
         },
         availabilityObject(){
             return this.$store.getters.getStockItem(this.product.SKU)
         }
     },
     methods: {
         scrollToTop() {
             window.scrollTo(0,0);
         },
       clearReplacementProduct(){
          this.emitter.emit('replacement-cleared')
       },
         getAmountClass(product){
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){
                 return 'availability-unbuyable'
             }
             if(stockObj.state.buyable){
                 if(stockObj.qty <= 0){
                     return 'availability-unavailable'
                 }else if(stockObj.qty < 15){
                     return 'availability-low'
                 }else {
                     return 'availability-available'
                 }
             }else{
                 return 'availability-unbuyable'
             }
         },
         orderListAmount (sku) {
             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(sku) && item.productTypeId === this.line_type
             })
           console.log(this.custlist.lines);
             if (arr.length) {
                console.log(arr[0]);
                 return arr[0].quantity
             }
             return 0
         },
       setReplacementProduct(){
           this.$emit('add-replacement-product',this.$props.product.SKU);
       },
         getAvailable(product){
             //console.log("ProductListElement:getAvailable");
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){

                 return '0'
             }
             if (!stockObj.state.buyable) {
                 return '0'
             } else {
                 if (stockObj.qty <= 0){
                     return '0'
                 } else {
                     if (stockObj.qty > stockObj.roof){
                         return '> ' + stockObj.displayQty
                     } else {
                         return stockObj.qty
                     }
                 }
             }
         }

     }

 }
</script>

<style scoped>

</style>
